<template>
  <div class="control-panel">
    <div class="control-panel-elements">
      <div class="simulation-panel panel">
        <div class="panel-title">
        </div>
        <div class="simulation-panel-container">
          <simulation-panel v-on:displayError="displayError"/>
          <div class="line-separator"></div>
          <div class="column-controls">
            <HardwarePanel v-on:displayError="displayError"/>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center mt-5 pt-4">
      <b-alert id="error-message" variant="danger" v-model="this.showError" dismissible @dismissed="this.hideError">
        {{ error }}
      </b-alert>
    </div>
  </div>

</template>

<script>
import SimulationPanel from './SimulationPanel.vue';
import HardwarePanel from "./HardwarePanel";

export default {
  name: 'ControlPanel',
  props: {
    error: String,
  },
  data() {
    return {
      showError: false
    };
  },
  components: {
    HardwarePanel,
    SimulationPanel,
  },
  methods: {
    displayError(error) {
      this.error = error;
      this.showError = true;
    },
    hideError() {
      this.showError = false;
    }
  }
}
</script>

<style scoped>
.control-panel {
  display: flex;
  flex-direction: column;
  height: 300px;
  background-color: rgba(0, 0, 0, 0.73);
}

.control-panel-elements {
  display: flex;
  flex-direction: row;
}

.line-separator {
  height: 95%;
  margin-top: 1%;
  border-left: solid rgba(255, 255, 255, 0.2) 1px
}

@font-face {
  font-family: "Gotham Book";
  src: url("../../public/fonts/Gotham-Book.woff2");
}

@font-face {
  font-family: "Gotham Medium";
  src: url("../../public/fonts/GothamMedium.ttf");
}

.simulation-panel {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  color: white;
  font-family: "Gotham Book", serif;
  padding-left: 2%;
  padding-right: 2%;
}

.simulation-panel-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.column-controls {
  display: flex;
  flex-direction: column;
}

.panel-title {
  font-family: "Gotham Book", sans-serif;
  justify-content: center;
  font-size: 18px;
  margin-bottom: 25px;
}

.line-separator {
  height: 87%;
  margin-top: 4%;
  border-left: solid rgba(255, 255, 255, 0.2) 1px
}

</style>